import cn from 'classnames';
import { Badge, Typography } from 'seagull';
import styles from "./RecipientDetails.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const typographySkinMap = {
  default: 'secondary',
  error: 'error',
  success: 'success',
  warning: 'warning',
  primary: 'primary'
};
const RecipientDetails = _ref => {
  let {
    email,
    lastName,
    firstName,
    companyName,
    badge,
    requiredBadgeSkin = 'default',
    signedBadgeSkin = 'success',
    testid = 'recipient-details',
    className
  } = _ref;
  const fullName = "".concat(firstName || '', " ").concat(lastName || '').trim();
  const company = companyName ? " (".concat(companyName, ")") : '';
  const emailSuffix = email ? ", ".concat(email) : '';
  const displayText = "".concat(fullName).concat(company).concat(emailSuffix);
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.recipientDetails, className),
    "data-testid": testid,
    children: [/*#__PURE__*/_jsx(Typography, {
      "data-testid": "".concat(testid, "-text"),
      children: displayText
    }), badge === 'required' && /*#__PURE__*/_jsx(Badge, {
      rounded: true,
      outlined: true,
      skin: requiredBadgeSkin,
      children: /*#__PURE__*/_jsx(Typography, {
        skin: typographySkinMap[requiredBadgeSkin],
        variant: "paragraph2",
        "data-testid": "".concat(testid, "-required-badge-text"),
        children: "Required to sign"
      })
    }), badge === 'signed' && /*#__PURE__*/_jsx(Badge, {
      rounded: true,
      outlined: true,
      skin: signedBadgeSkin,
      children: /*#__PURE__*/_jsx(Typography, {
        skin: typographySkinMap[signedBadgeSkin],
        variant: "paragraph2",
        "data-testid": "".concat(testid, "-signed-badge-text"),
        children: "Signed"
      })
    })]
  });
};
export default RecipientDetails;